import React, { useContext } from "react";
import { ProjectContext, Sds } from "@swegon/sds-core";

export const SdsWrapper = ({ children }) => {
    const { project } = useContext(ProjectContext);

    return (
        <Sds items={[]} name={project ? project.Name : ""} useSdsPrint={false}>
            {children}
        </Sds>
    );
};
export default SdsWrapper;
